// extracted by mini-css-extract-plugin
module.exports = {"product-description":"product-description_product-description__ocieU","cat-reman-icon":"product-description_cat-reman-icon__ccSiO"};